import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "us.collection/services";
import * as Actions from "us.collection/actions";
import { ExtendedField } from "us.collection/constants";
import { formatMetaData } from "us.collection/functions/ExtendedField";
import Common from "us.common";
import { i18n } from "us.helper";
import { isArray } from "lodash";

const { $MessageBox, $Message } = Common.Components;

const { extendedField } = Actions;

const ExtendedFieldSagas = {
  /**
   * Get extended field on us.collection.case
   * @param action
   */
  get: function* (action: any) {
    const params = action?.payload?.data ?? {};
    try {
      const { data, status } = yield call(
        API.extendedField.extendedFields.get,
        params
      );
      if (data?.errors || data?.statusCode) {
        yield put(extendedField.extendedFields.fail(data?.errors[0]?.error));
      } else if (status == 204) {
        yield put(extendedField.extendedFields.fail({}));
      } else {
        yield put(extendedField.extendedFields.success(data));
      }
    } catch (error) {
      yield put(extendedField.extendedFields.fail(error as any));
      console.error(error);
    }
  },
  getMetaData: function* (action: any): any {
    try {
      const { category } = action?.payload?.data;
      const { data, status } = yield call(
        API.extendedField.extendedFields.getMetaData
      );
      if (Array.isArray(data) && status === 200) {
        yield put(
          extendedField.metaData.success(formatMetaData(data, category))
        );
      } else {
        yield put(extendedField.metaData.fail(new Error()));
      }
    } catch (error) {
      yield put(extendedField.metaData.fail(new Error()));
    }
  },
  update: function* (action: any): any {
    const params = action?.payload?.data ?? {};
    const { category, request } = params;
    const isNew =
      isArray(request) && request.some((item: any) => item?.itemId === -1);
    try {
      const { data, status } = yield call(
        API.extendedField.extendedFields.save,
        params
      );
      if (status === 200 || status === 201) {
        const { data: fields } = yield call(
          API.extendedField.extendedFields.get,
          { category: category, entityId: request[0]?.entityId }
        );
        if (fields?.errors || fields?.statusCode) {
          yield put(
            extendedField.extendedFields.fail(fields?.errors[0]?.error)
          );
        } else {
          yield put(extendedField.extendedFields.success(fields));
        }
        yield put(extendedField.extendedFieldData.success(data));
        $MessageBox(
          "success",
          isNew
            ? "US.COLLECTION.COMMON:EXTENDED_FIELD.ADDITIONAL_INFORMATION_HAS_BEEN_ADDED_SUCCESSFULLY"
            : "US.COLLECTION.COMMON:EXTENDED_FIELD.ADDITIONAL_INFORMATION_HAS_BEEN_UPDATED_SUCCESSFULLY",
          "",
          ""
        );
      } else if (status === 401) {
        yield put(extendedField.extendedFieldData.fail(new Error()));
        $MessageBox(
          "error",
          "US.COMMON.ADMIN:EXTENDED_FIELDS.NO_PRIVILEGE_TO_EDIT",
          "",
          ""
        );
      } else {
        yield put(extendedField.extendedFieldData.fail(new Error()));
        $MessageBox(
          "error",
          isNew
            ? "US.COLLECTION.COMMON:EXTENDED_FIELD.FAILED_TO_ADD_ADDITIONAL_INFORMATION"
            : "US.COLLECTION.COMMON:EXTENDED_FIELD.FAILED_TO_UPDATE_ADDITIONAL_INFORMATION",
          "",
          ""
        );
      }
    } catch (error) {
      yield put(extendedField.extendedFieldData.fail(new Error()));
      $MessageBox(
        "error",
        isNew
          ? "US.COLLECTION.COMMON:EXTENDED_FIELD.FAILED_TO_ADD_ADDITIONAL_INFORMATION"
          : "US.COLLECTION.COMMON:EXTENDED_FIELD.FAILED_TO_UPDATE_ADDITIONAL_INFORMATION",
        "",
        ""
      );
    }
  },
  delete: function* (action: any): any {
    const params = action?.payload?.data ?? {};
    const { entityId, request } = params;
    $Message.loading(i18n.t("COMMON.DELETING") as string, 0);

    try {
      const { data, status } = yield call(
        API.extendedField.extendedFields.delete,
        request
      );
      if (status === 200) {
        const { data: fields, status } = yield call(
          API.extendedField.extendedFields.get,
          { category: request?.category, entityId: entityId }
        );
        if (status === 200) {
          yield put(extendedField.extendedFields.success(fields));
        } else if (fields?.errors || fields?.statusCode) {
          yield put(
            extendedField.extendedFields.fail(fields?.errors[0]?.error)
          );
        } else {
          yield put(extendedField.extendedFields.success([]));
        }
        yield put(extendedField.deleteExtendedField.success(data));
        $Message.destroy();
        $MessageBox(
          "success",
          "US.COMMON:EXTENDED_FIELDS.EXTENDED_FIELD_HAS_BEEN_DELETED_SUCCESSFULLY",
          "",
          ""
        );
      } else if (status === 401) {
        yield put(extendedField.deleteExtendedField.fail(new Error()));
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COMMON:EXTENDED_FIELDS.NO_PRIVILEGE_TO_DELETE",
          "",
          ""
        );
      } else {
        yield put(extendedField.deleteExtendedField.fail(new Error()));
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COMMON:EXTENDED_FIELDS.FAILED_TO_DELETE_EXTENDED_FIELD",
          "",
          ""
        );
      }
    } catch (error) {
      yield put(extendedField.deleteExtendedField.fail(new Error()));
      $Message.destroy();
      $MessageBox(
        "error",
        "US.COMMON:EXTENDED_FIELDS.FAILED_TO_DELETE_EXTENDED_FIELD",
        "",
        ""
      );
    }
  },
};

export default [
  takeLatest(ExtendedField.GET_EXTENDED_FIELD, ExtendedFieldSagas.get),
  takeLatest(
    ExtendedField.GET_EXTENDED_FIELD_META_DATA,
    ExtendedFieldSagas.getMetaData
  ),
  takeLatest(ExtendedField.UPDATE_EXTENDED_FIELD, ExtendedFieldSagas.update),
  takeLatest(ExtendedField.DELETE_EXTENDED_FIELD, ExtendedFieldSagas.delete),
];
